import type { z } from "zod";
import type { SunProtectionSettings } from "../sun-protection-settings.types";
import type { settingsSchema } from "../schemas/sun-protection-settings.schema";
import { settingsResponseSchema } from "../schemas/sun-protection-settings.schema";

export function parseSunProtectionSettings(
    raw: z.infer<typeof settingsSchema>,
): SunProtectionSettings {
    return raw;
}

export function parseSunProtectionSettingsResponse(
    raw: unknown,
): SunProtectionSettings | undefined {
    const result = settingsResponseSchema.safeParse(raw);
    if (!result.success) {
        console.warn("failed to parse GlobalSetting response", result.error);
        return undefined;
    }
    return result.data.GlobalSetting;
}
